import { render, staticRenderFns } from "./BadgeListItem.vue?vue&type=template&id=7bd658f8&scoped=true"
import script from "./BadgeListItem.vue?vue&type=script&lang=js"
export * from "./BadgeListItem.vue?vue&type=script&lang=js"
import style0 from "./BadgeListItem.vue?vue&type=style&index=0&id=7bd658f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd658f8",
  null
  
)

export default component.exports